import React from "react";
import {
  SkeletonWrapper,
  HeroSkeletonWrapper,
  FiltersSkeletonWrapper,
  AccountsSkeletonWrapper,
  SkeletonBox,
} from "./styles";

/**
 * Skeleton loading state for AccountsPage
 * Mirrors the real layout: a single hero stats strip, a filter row of
 * year dropdown + active-only toggle, and the responsive account card grid.
 */
export const AccountsSkeleton: React.FC = () => {
  return (
    <SkeletonWrapper aria-label="Loading accounts" aria-live="polite">
      {/* Hero strip: Current Value + Deposited / Withdrawn summary */}
      <HeroSkeletonWrapper>
        <SkeletonBox width="100%" height="100%" />
      </HeroSkeletonWrapper>

      {/* Filter row: year dropdown + active-only toggle */}
      <FiltersSkeletonWrapper>
        <SkeletonBox width="160px" height="44px" />
        <SkeletonBox width="120px" height="44px" />
      </FiltersSkeletonWrapper>

      {/* Account cards grid */}
      <AccountsSkeletonWrapper>
        <SkeletonBox height="280px" />
        <SkeletonBox height="280px" />
        <SkeletonBox height="280px" />
        <SkeletonBox height="280px" />
      </AccountsSkeletonWrapper>
    </SkeletonWrapper>
  );
};
